// extracted by mini-css-extract-plugin
module.exports = {"contactBackFailIcon":"contact-back-Fail_contactBackFailIcon__1qcrn","img":"contact-back-Fail_img__Wa0dR","btnInsure":"contact-back-Fail_btnInsure__233Ft"};